module.exports = __webpack_public_path__ + "img/pIndex-about1.464b5011.jpg";